export const ArrowBackIcon = ({ color = '#004dbc', width = '13.503', height = '23.619' }) => {
  return (
    <svg
      data-name="Icon Back"
      height={height}
      id="Icon_Back"
      viewBox="0 0 13.503 23.619"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.321,18l8.937-8.93a1.688,1.688,0,0,0-2.391-2.384L11.742,16.8a1.685,1.685,0,0,0-.049,2.327L21.86,29.32a1.688,1.688,0,0,0,2.391-2.384Z"
        data-name="Icon ionic-ios-arrow-back"
        fill={color}
        id="Icon_ionic-ios-arrow-back"
        transform="translate(-11.251 -6.194)"
      />
    </svg>
  );
};
